export * from './placeholder'
export * from './lazyload'
export * from './sns'
export * from './loadStatus'
export * from './apiPath'
export * from './error'
export * from './taxRate'

export const APP_PATH_REGEX = {
  SEARCH: /^\/search/
}

export enum APP_EVENTS {
  SEARCH_KEYWORD_APPLY = 'search_keyword_apply'
}